var render, staticRenderFns
import script from "./ClPaper.ts?vue&type=script&lang=ts&"
export * from "./ClPaper.ts?vue&type=script&lang=ts&"
import style0 from "./ClPaper.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports